import { ScheduleTargetType } from '@/constants';
import ContentPayloadForm from './content-payload-form';
import CoursePayloadForm from './course-payload-form';
import { darkDangerText } from '@/shared/dark-inline-styles';

interface Props {
    targetType: ScheduleTargetType;
    initialPayload: Record<string, unknown>;
    onChange: (payload: Record<string, unknown>) => void;
}

/**
 * Dispatcher — picks the right per-type payload editor. New target type =
 * add a case here (and a sibling form component). Form components own their
 * own field state + emit a deduped Record<string, unknown> matching the
 * API handler's expected shape.
 */
const PayloadForm = ({ targetType, initialPayload, onChange }: Props) => {
    switch (targetType) {
        case ScheduleTargetType.Content:
            return <ContentPayloadForm initialPayload={initialPayload} onChange={onChange} />;
        case ScheduleTargetType.Course:
            return <CoursePayloadForm initialPayload={initialPayload} onChange={onChange} />;
        default:
            return <p style={{ color: darkDangerText }}>Unsupported target type — admin needs an update.</p>;
    }
};

export default PayloadForm;
